import WidgetFormField from './WidgetFormField';
import { ReadOnlyInput } from '@athena/forge';
import { useWidgetContext } from '../context/WidgetContext';
import { getLocalizedString } from '../../utils/i18n-utils';

export default function ImpersonatedUsernameField() {
  const { athenaOneParams, athenaOneWebSso } = useWidgetContext();
  if (athenaOneWebSso && athenaOneParams?.SSOREAUTHPARAMS?.SUPERUSERNAME) {
    return (
      <WidgetFormField
        id={'athena-impersonated-username'}
        inputAs={ReadOnlyInput}
        labelAlwaysAbove
        text={athenaOneParams.SSOREAUTHPARAMS.SUPERUSERNAME}
        labelText={getLocalizedString('impersonated.username.field.label')}
        className={'fe_u_font-weight--semibold fe_u_margin--bottom-medium'}
      />
    );
  }
  return <></>;
}
